import React from 'react';
import cn from 'classnames';
import { Props } from '../InlineView';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Timestamp from '../../../Timestamp';

import s from './Poll.scss';

const MAX_QUESTION_LENGTH = 55;

const PollInlineView: React.FC<Props> = props => {
  const { deviation, width, height } = props;

  const { poll } = deviation;

  const questionTruncated =
    poll?.question && poll.question.length > MAX_QUESTION_LENGTH
      ? `${poll.question.slice(0, MAX_QUESTION_LENGTH)}...`
      : poll?.question;

  const isSmall = (height ?? 0) <= 150;

  return (
    <div className={cn(s['root'], isSmall && s['tiny'])} style={{ width, height }}>
      <Section>
        <Heading className={s['question']}>{questionTruncated}</Heading>
        <div className={s['info']}>
          <span className={s['date']}>
            <Timestamp timestamp={poll?.ts} />
          </span>
          &nbsp; | &nbsp;
          <span className={s['vote-count']}>{poll?.votes} votes</span>
        </div>
      </Section>
    </div>
  );
};
PollInlineView.displayName = 'PollInlineView';

export default PollInlineView;
